<template>
  <v-card v-if="visible" class="reason-section-card" outlined>
    <v-card-title class="reason-title">
      <span>{{ title }}</span>
    </v-card-title>
    <v-card-text class="reason-content">
      <div class="no-break reason-message" v-html="message"></div>
      <v-text-field
        v-model="reasonText"
        label="Reason"
        placeholder="Reason"
        outlined
        dense
        class="reason-text-field"
        :rules="[value => !!value && value.trim() !== '' || 'Reason is required']"
      />
    </v-card-text>
    <v-card-actions class="reason-actions">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="confirm" :disabled="!canConfirm">{{ confirmLabel }}</v-btn>
      <!-- <v-btn color="secondary" @click="cancel">{{ cancelLabel }}</v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'reasonSection',
  props: {
    // showTextField prop removed, now handled by selectedReason === 'Other'
    confirmLabel: { type: String, default: 'Confirm' },
    cancelLabel: { type: String, default: 'Cancel' },
    context: { type: String, default: '' },
    value: { type: Boolean, default: false }
  },
  data () {
    return {
      visible: false,
      reasonText: '',
      title: '',
      message: ''
    }
  },
  computed: {
    canConfirm () {
      return !!this.reasonText && this.reasonText.trim().length > 0
    }
  },
  methods: {
    open (title, message) {
      this.visible = true
      this.title = title
      this.message = message
      this.reasonText = ''
      return new Promise((resolve, reject) => {
        // Wrap resolve to auto-close dialog
        this.resolve = (value) => {
          this.visible = false
          resolve(value)
        }
        this.reject = reject
      })
    },
    confirm () {
      const reason = this.reasonText ? this.reasonText.trim() : ''
      if (reason !== '') {
        this.resolve({ reason, context: this.context })
      } else {
        this.$snotify.error('Please enter a reason before confirming.')
      }
    },
    cancel () {
      this.resolve()
    },
    reset () {
      this.visible = false
      this.resolve = null
      this.reject = null
    }
  }
}
</script>

<style scoped>
.reason-section-card {
  background: #f8f9fa !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.15) !important;
  max-width: 600px;
  margin: 16px auto;
}

.reason-title {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  color: #1a1a1a;
  padding: 20px 24px 12px !important;
}

.reason-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px 20px !important;
}

.reason-message {
  font-size: 0.95rem;
  color: #333333;
  line-height: 1.5;
}

.reason-radio-group {
  margin-top: 8px;
}

.reason-text-field {
  margin-top: 4px;
}

.reason-actions {
  padding: 10px 14px 10px !important;
  background: #ffffff;
  border-top: 1px solid #e0e0e0;
}

@media (max-width: 600px) {
  .reason-section-card {
    max-width: 95vw !important;
    margin: 12px auto;
  }

  .reason-title {
    font-size: 1rem !important;
    padding: 16px 20px 10px !important;
  }

  .reason-content {
    padding: 10px 20px 16px !important;
  }

  .reason-actions {
    padding: 10px 20px 16px !important;
  }
}

.no-break {
  /* Prevent words being split across lines while still allowing normal wrapping between words */
  white-space: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  hyphens: none;
}
</style>
